// extracted by mini-css-extract-plugin
module.exports = {"root":"j7DdpwRBtCwWuIQ47z6ji","container":"_2Ia9veSWInS8OLOIOmFRaW","color":"_3wh6XWf0Fx37LXNDSg7zKg","selected":"_3AtB7WY42RmR36_zJSPrpU"};